<template>
  <vi-page>
    <vi-card no-header :sync="sync">
      <VCDataTable
        v-if="userSN"
        v-bind="dtable"
        @e-row-action="eRowAction"
        ref="dataTable"
      >
        <template v-slot:header-init>
          <div class="row">
            <div class="col text-right">
              <button
                type="reset"
                class="btn btn-primary"
                @click="eExport"
                :content="`注意：若不指定创建时间范围，默认只导出最近90天的数据`"
                v-tippy="{
                  placement: 'bottom',
                  theme: 'light',
                  arrow: true,
                  animation: 'shift-toward',
                }"
              >
                账单导出
              </button>
            </div>
          </div>
        </template>
        <template v-slot:table_col_originalAmount="scope">
          <vi-amount v-model="scope.row.originalAmount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_taxAmount="scope">
          <vi-amount v-model="scope.row.taxAmount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_discountAmount="scope">
          <vi-amount v-model="scope.row.discountAmount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_roundAmount="scope">
          <vi-amount v-model="scope.row.roundAmount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_amount="scope">
          <vi-amount v-model="scope.row.amount" :prefix="prefix" />
        </template>

        <template #search-append>
          <div class="d-flex align-items-center ml-3">
            <span>账单类型：</span>
            <div style="width: 150px">
              <vi-selector v-model="type" :options="typeList"> </vi-selector>
            </div>
          </div>
          <div class="d-flex align-items-center ml-3">
            <span>支付状态：</span>
            <div style="width: 150px">
              <vi-selector v-model="status" :options="statusList">
              </vi-selector>
            </div>
          </div>
          <div class="d-flex align-items-center ml-3 mt-2">
            <span class="ml-3">创建时间范围（1-90天）：</span>
            <div>
              <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 400px"
              >
              </el-date-picker>
            </div>
          </div>
          <button
            type="reset"
            class="btn btn-primary mt-2 ml-4"
            @click="eFilter"
            style="width: 80px"
          >
            搜索
          </button>
        </template>

      </VCDataTable>
    </vi-card>
  </vi-page>
</template>

<script>
import VCDataTable from "@leiweb/kernel-dashboard/src/controls/data/DataTable";
import { v1 as uuidv1 } from "uuid";
var moment = require("moment");
export default {
  name: "PagesDashboardShiyunCostBill",
  components: {
    VCDataTable,
  },
  data() {
    return {
      dtable: {
        label: "费用账单",
        url: "/shiyun/marketing/apis/biz/customer/bill/internal/page",
        params: { userSN: "SN-0" },
        orderBy: { name: "ID", type: "Desc" },
        search: {
          placeholder: "输入关键词检索",
        },
        fields: [
          { name: "sn", type: "text", label: "账单号" },
          {
            name: "name",
            type: "text",
            label: "概要",
          },

          {
            name: "type",
            type: "select",
            label: "类型",
            options: [
              { value: "Prepay", label: "预付费" },
              { value: "Postpay", label: "后付费" },
              { value: "Refund", label: "退款" },
              { value: "Adjustment", label: "调账" },
            ],
          },
          {
            name: "originalAmount",
            type: "slot",
            label: "原价",
          },
          {
            name: "taxAmount",
            type: "slot",
            label: "税费金额",
          },
          {
            name: "discountAmount",
            type: "slot",
            label: "优惠金额",
          },
          {
            name: "roundAmount",
            type: "slot",
            label: "抹零金额",
          },
          {
            name: "amount",
            type: "slot",
            label: "应付金额",
          },
          {
            name: "status",
            type: "select",
            label: "状态",
            options: [
              { value: "New", label: "新账单" },
              { value: "Paid", label: "已支付" },
              { value: "Canceled", label: "取消" },
              { value: "Remove", label: "废弃" },
              { value: "WaitPay", label: "待支付" },
            ],
          },
          {
            name: "paymentTime",
            type: "date",
            label: "创建时间",
            format: "YYYY-MM-DD HH:mm:ss",
          },
          {
            name: "time",
            type: "date",
            label: "同步时间",
            format: "YYYY-MM-DD HH:mm:ss",
          },
        ],
        add: {
          enable: false,
        },
        edit: {
          enable: false,
        },
        rowActions: [{ name: "base", icon: "fas:bars", tips: "详情" }],
      },
      custmoerList: [{ label: "全部", value: "all" }],
      custmoerSN: "",
      params: {},
      dateVal: moment().format("x") * 1,
      prefix: "",
      userSN: "",
      sync: false,
      status: "all",
      statusList: [
        { label: "全部", value: "all" },
        { value: "New", label: "新账单" },
        { value: "Paid", label: "已支付" },
        { value: "Canceled", label: "取消" },
        { value: "Remove", label: "废弃" },
        { value: "WaitPay", label: "待支付" },
      ],
      type: "all",
      typeList: [
        { label: "全部", value: "all" },
        { value: "Prepay", label: "预付费" },
        { value: "Postpay", label: "后付费" },
        { value: "Refund", label: "退款" },
        { value: "Adjustment", label: "调账" },
      ],
      time: "",
      pickerMinDate: "",
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
          console.log(obj);
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 90 * 24 * 3600 * 1000;

            let maxTime = this.pickerMinDate + day1;
            let minTime = this.pickerMinDate - day1;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() >= Date.now()
            );
          } else {
            return time.getTime() >= Date.now();
          }
        },
      },
    };
  },
  mounted() {
    this.oGetUser();
    this.prefix = this.$$.currency.prefix();
  },

  methods: {
    oGetUser() {
      this.$$.api
        .post("/kernel/authentication/apis/biz/user/current")
        .then((res) => {
          this.userSN = res.data.user.sn;
          this.dtable.params = {
            userSN: res.data.user.sn,
          };
          this.eGetCustomer();
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
        });
    },
    eGetCustomer() {
      this.$$.api.data
        .find("/shiyun/aliyun/apis/data/customer", {
          columns: ["*"],
          requirement: {
            filters: [{ Name: "userSN", Type: "Equal", Value: this.userSN }],
          },
        })
        .then((res) => {
          this.custmoerSN = res.data.item.userSN;
        });
    },
    eRowAction(action, row) {
      if (action.name == "base") {
        this.$$.navigate.to({
          label: `详情[${row.name}]`,
          path: `/shiyun/cost/bill/${row.sn}/detail`,
        });
      }
    },
    eExport() {
      this.sync = true;
      let args = {
        customerSN: this.custmoerSN,
      };
      if (this.time) {
        args.startTime = moment(this.time[0]).startOf("day").format("x");
        args.finishTime = moment(this.time[1]).endOf("day").format("x");
      }
      if (this.status && this.status !== "all") {
        args.status = this.status;
      }
      if (this.type && this.type !== "all") {
        args.type = this.type;
      }
      this.$$.api
        .download("/shiyun/marketing/apis/biz/customer/bill/exportBiz", args)
        .then((res) => {
          const blob = new Blob([res]);
          const type = res.type;
          const netDate = moment(new Date()).format("YYYY-MM-DD");

          // let fn = "客户账单" + "(" + netDate + ")" + type;
          let fn = `费用账单（${netDate}）${type}`;
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");

            link.download = fn;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          } else {
            navigator.msSaveBlob(blob, fn);
          }
          this.sync = false;
          this.$$.toastr.success("导出成功！");
        })
        .catch((e) => {
          this.$$.swal.error(`${e.message}`);
          this.sync = false;
        });
    },
    eFilter() {
      this.dtable.params = [];
      this.dtable.params.push(`userSN == ${this.userSN}`);

      if (!this.custmoerSN == "all" && this.status == "all") {
        this.$$.toastr.error("请选择搜索条件");

        return;
      }
      if (this.time) {
        this.dtable.params.push(
          `startTime >= ${moment(this.time[0]).startOf("day").format("x")}`
        );
        this.dtable.params.push(
          `finishTime <= ${moment(this.time[1]).endOf("day").format("x")}`
        );
      }
      if (this.type != "all" && this.type) {
        this.dtable.params.push(`type == ${this.type}`);
      }
      if (this.status != "all" && this.status) {
        this.dtable.params.push(`status == ${this.status}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bill_select {
  display: flex;
  flex-wrap: wrap;
}
.select_width {
  width: 170px;
}
.date_width {
  width: 200px;
}
.date_margin {
  margin: 0 5px;
}
.row_p {
  position: relative;
  .m_condition {
    position: absolute;
    right: 5px;
    top: 5px;
    display: flex;
    align-items: center;
    i {
      padding-bottom: unset;
    }
  }
}
</style>